module.exports = __webpack_public_path__ + "static/img/009城市名片9.79c68d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/009城市名片9.jpg
// module id = N06G
// module chunks = 0